import { render, staticRenderFns } from "./InnerPageMessage.vue?vue&type=template&id=c4fce464"
import script from "./InnerPageMessage.vue?vue&type=script&lang=js"
export * from "./InnerPageMessage.vue?vue&type=script&lang=js"
import style0 from "./InnerPageMessage.vue?vue&type=style&index=0&id=c4fce464&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4fce464')) {
      api.createRecord('c4fce464', component.options)
    } else {
      api.reload('c4fce464', component.options)
    }
    module.hot.accept("./InnerPageMessage.vue?vue&type=template&id=c4fce464", function () {
      api.rerender('c4fce464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/page/InnerPageMessage.vue"
export default component.exports